import * as React from 'react';
import { Link } from 'gatsby';
import { Paper, Grid } from '@material-ui/core';
import { 
  poemPreviewLink,
  poemPreview,
  poemPreviewTitle, 
  poemPreviewText  
} from './layout.module.css';

const PoemRow = ({ row, mobile }) => {
    var poemList = [];
    for (var i = 0; i < row.length; i++) {
      let previewText = row[i].frontmatter.preview.split('/');

      poemList.push(
        <Grid item xs={4} key={'poem_' + i}>
          <Link className={poemPreviewLink} to={`/poems/${row[i].slug}`}>
            <Paper className={poemPreview} elevation={2}>
              <div>
                <div className={poemPreviewTitle}>
                  {mobile && row[i].frontmatter.abbreviated ? row[i].frontmatter.abbreviated : row[i].frontmatter.title}
                </div>
                <div>
                  {mobile ? null : previewText.map((line, i) => <div className={poemPreviewText} key={previewText[i]}>{line}</div>)}
                </div>
              </div>
            </Paper>
          </Link>
        </Grid>)
    }
    return (
      <React.Fragment>
        {poemList}
      </React.Fragment>
    );
  }

export default PoemRow;
